import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MenuGroup } from '../../models/menu-item.model';
import { VerticalMenuItemComponent } from '../vertical-menu-item/vertical-menu-item.component';

@Component({
  selector: 'app-vertical-menu-group',
  imports: [VerticalMenuItemComponent],
  templateUrl: './vertical-menu-group.component.html',
  styleUrl: './vertical-menu-group.component.scss'
})
export class VerticalMenuGroupComponent {
  @Input({ required: true }) group!: MenuGroup;
  @Input() activePath = '';
  @Input() expanded = false;
  @Output() toggled = new EventEmitter<void>();
}
